export default "__VITE_ASSET__DfE7PqJY__"